// Convert jQuery event listener to vanilla JS
document.addEventListener('click', function(event) {
    // Check if clicked element or any parent has the class 'ais-facet--header'
    const clickedElement = event.target.closest('.ais-facet--header');
    
    if (clickedElement) {
      const parentElement = clickedElement.parentElement;
      
      // Show the .ais-Panel
      const aisPanel = parentElement.querySelector('.ais-Panel');
      if (aisPanel) {
        aisPanel.style.display = 'block';
      }
      
      // Remove 'active' class from all .ais-header elements
      const aisHeaders = document.querySelectorAll('.ais-header');
      aisHeaders.forEach(header => header.classList.remove('active'));
      
      // Find the dropdown container in the parent
      const dropdownContainer = parentElement.querySelector('.custom-ais-facet-dropdown-container');
      
      if (dropdownContainer && dropdownContainer.classList.contains('active')) {
        // If dropdown is active, deactivate it
        dropdownContainer.classList.remove('active');
        dropdownContainer.style.display = 'none';
        
        // Hide filter overlay
        const filterOverlay = document.querySelector('.filter-overlay');
        if (filterOverlay) {
          filterOverlay.style.display = 'none';
        }
      } else {
        // If dropdown is not active, activate it
        const filterOverlay = document.querySelector('.filter-overlay');
        if (filterOverlay) {
          filterOverlay.style.display = 'block';
        }
        
        // Remove 'active' class from all dropdown containers
        const allDropdownContainers = document.querySelectorAll('.custom-ais-facet-dropdown-container');
        allDropdownContainers.forEach(container => container.classList.remove('active'));
        
        // Activate current dropdown container
        if (dropdownContainer) {
          dropdownContainer.classList.add('active');
          
          // Add 'active' class to ais-header in parent
          const aisHeader = parentElement.querySelector('.ais-header');
          if (aisHeader) {
            aisHeader.classList.add('active');
          }
          
          // Get container width and adjust if necessary
          const containerWidth = dropdownContainer.offsetWidth;
          
          if (containerWidth > 240) {
            dropdownContainer.style.width = '280px';
          }
          if (containerWidth > 300) {
            dropdownContainer.style.width = '350px';
          }
        }
      }
    }
});

// Convert jQuery click listener to vanilla JS (delegated)
document.addEventListener('click', function(event) {
    // Handle clicks on the close button or any of its children
    const closeBtn = event.target.closest('.ais-facet-dropdown-close-btn');
    if (!closeBtn) return;
  
    // Remove 'active' class from all .ais-header elements
    const aisHeaders = document.querySelectorAll('.ais-header');
    aisHeaders.forEach(header => header.classList.remove('active'));
  
    // Remove 'active' class from all .ais-header elements
    const aisHeaders_dropdown = document.querySelectorAll('.custom-ais-facet-dropdown-container');
    aisHeaders_dropdown.forEach(header => header.classList.remove('active'));
  
    // Hide the filter overlay
    const filterOverlay = document.querySelector('.filter-overlay');
    if (filterOverlay) {
      filterOverlay.style.display = 'none';
    }
});

document.addEventListener('click', function(event) {
    const clickedInsideDropdown = event.target.closest('.ais-facet-dropdown-wrapper');
    const clickedCheckbox = event.target.classList.contains('ais-RefinementList-checkbox');
  
    // If click is outside the dropdown wrapper and not on a checkbox
    if (!clickedInsideDropdown && !clickedCheckbox) {
      // Remove 'active' class from dropdown containers
      document.querySelectorAll('.custom-ais-facet-dropdown-container')
        .forEach(container => container.classList.remove('active'));
  
      // Remove 'active' class from headers
      document.querySelectorAll('.ais-facet--header')
        .forEach(header => header.classList.remove('active'));
    }
});

document.addEventListener('DOMContentLoaded', async function() {
    // Wait for element function (replacement for waitForElm)
    function waitForElement(selector) {
      return new Promise(resolve => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }
  
        const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
            observer.disconnect();
            resolve(document.querySelector(selector));
          }
        });
  
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }
  
    // Helper functions
    function addClass(element, className) {
      if (element) element.classList.add(className);
    }
  
    function removeClass(element, className) {
      if (element) element.classList.remove(className);
    }
  
    function hasClass(element, className) {
      return element ? element.classList.contains(className) : false;
    }
  
    function closest(element, selector) {
      return element ? element.closest(selector) : null;
    }
  
    // Wait for the search box element
    let elem = await waitForElement('.ais-search-box-container .ais-SearchBox');
    
    // Set placeholder based on window width
    const searchInput = document.querySelector('.ais-SearchBox-input');
    if (searchInput) {
      if (window.innerWidth < 830) {
        searchInput.setAttribute('placeholder', 'Search this collection');
      } else {
        searchInput.setAttribute('placeholder', 'Search this collection');
      }
    }
  
    const sortElement = document.querySelector('.ais-pages .ais-sort');
    const facetsContainer = document.querySelector('.ais-pages .ais-facets');

    if (sortElement && facetsContainer) {
        facetsContainer.appendChild(sortElement);
    }

    const clearRefinementsContainer = document.querySelector('.ais-clear-refinements-container');
    
    const refinedvaluescontainer = document.querySelector('.ais-pages .ais-current-refined-values-container');
    
    if (clearRefinementsContainer && refinedvaluescontainer) {
        refinedvaluescontainer.appendChild(clearRefinementsContainer);
    }
    // Focus event handler
    function handleFocus(event) {
      const form = closest(event.target, 'form');
      const aisPage = closest(event.target, '.ais-pages');
      const facetsButton = aisPage ? aisPage.querySelector('.ais-facets-button') : null;
      const sortButton = aisPage ? aisPage.querySelector('.ais-sort-button') : null;
  
      addClass(form, 'form-focusing');
      removeClass(form, 'form-focused');
      addClass(facetsButton, 'input-focusing');
      removeClass(facetsButton, 'input-focused');
      addClass(sortButton, 'input-focusing');
      removeClass(sortButton, 'input-focused');
    }
  
    // Blur event handler
    function handleBlur(event) {
      const form = closest(event.target, 'form');
      const aisPage = closest(event.target, '.ais-pages');
      const facetsButton = aisPage ? aisPage.querySelector('.ais-facets-button') : null;
      const sortButton = aisPage ? aisPage.querySelector('.ais-sort-button') : null;
  
      if (event.target.value.trim() !== '') {
        removeClass(form, 'form-focusing');
        addClass(form, 'form-focused');
        removeClass(facetsButton, 'input-focusing');
        addClass(facetsButton, 'input-focused');
        removeClass(sortButton, 'input-focusing');
        addClass(sortButton, 'input-focused');
      } else {
        removeClass(form, 'form-focusing');
        removeClass(form, 'form-focused');
        removeClass(facetsButton, 'input-focusing');
        removeClass(facetsButton, 'input-focused');
        removeClass(sortButton, 'input-focusing');
        removeClass(sortButton, 'input-focused');
      }
    }
  
    // Input event handler
    function handleInput(event) {
      if (event.target.value.trim() !== '') {
        const form = closest(event.target, 'form');
        const aisPage = closest(event.target, '.ais-pages');
        const facetsButton = aisPage ? aisPage.querySelector('.ais-facets-button') : null;
        const sortsButton = aisPage ? aisPage.querySelector('.ais-sort-button') : null;
  
        addClass(form, 'form-focusing');
        addClass(facetsButton, 'input-focusing');
        addClass(sortsButton, 'input-focusing');
      }
    }
  
    // Add event listeners to search input
    if (searchInput) {
      searchInput.addEventListener('focus', handleFocus);
      searchInput.addEventListener('blur', handleBlur);
      searchInput.addEventListener('input', handleInput);
  
      // Initial check for existing value
      if (searchInput.value.trim() !== '') {
        const form = closest(searchInput, 'form');
        const aisPage = closest(searchInput, '.ais-pages');
        const facetsButton = aisPage ? aisPage.querySelector('.ais-facets-button') : null;
        const sortButton = aisPage ? aisPage.querySelector('.ais-sort-button') : null;
  
        addClass(form, 'form-focused');
        addClass(facetsButton, 'input-focused');
        addClass(sortButton, 'input-focused');
      }
    }
  
    // Handle all search inputs (in case there are multiple)
    const allSearchInputs = document.querySelectorAll('.ais-SearchBox-input');
    allSearchInputs.forEach(input => {
      if (input !== searchInput) { // Avoid duplicate listeners on the first input
        input.addEventListener('focus', handleFocus);
        input.addEventListener('blur', handleBlur);
        input.addEventListener('input', handleInput);
  
        // Initial check for existing value
        if (input.value.trim() !== '') {
          const form = closest(input, 'form');
          const aisPage = closest(input, '.ais-pages');
          const facetsButton = aisPage ? aisPage.querySelector('.ais-facets-button') : null;
          const sortButton = aisPage ? aisPage.querySelector('.ais-sort-button') : null;
  
          addClass(form, 'form-focused');
          addClass(facetsButton, 'input-focused');
          addClass(sortButton, 'input-focused');
        }
      }
    });
  
    // Reset button handler
    function handleResetMousedown(event) {
      const form = closest(event.target, 'form');
      const input = form ? form.querySelector('.ais-SearchBox-input') : null;
  
      if (form && hasClass(form, 'form-focused')) {
        event.preventDefault();
        event.stopPropagation();
  
        function clearAndTrigger() {
          if (input) {
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change'));
            removeClass(form, 'form-focused');
            removeClass(form, 'form-focusing');
            input.blur();
            
            // Focus body temporarily
            document.body.setAttribute('tabindex', '-1');
            document.body.focus();
            document.body.removeAttribute('tabindex');
          }
        }
  
        if (window.innerWidth < 829) {
          setTimeout(clearAndTrigger, 0);
        } else {
          clearAndTrigger();
        }
      }
    }
  
    // Add event listeners to reset buttons
    const resetButtons = document.querySelectorAll('.ais-SearchBox-reset');
    resetButtons.forEach(button => {
      button.addEventListener('mousedown', handleResetMousedown);
    });
});

document.addEventListener('algolia.instantSearch.onRender', function() {
    document.querySelectorAll('.ais-current-refined-values--item').forEach(function(elem, index) {
        // Find the div element within the current item
        const divElement = elem.querySelector('div');
        
        if (divElement) {
            // Get the HTML content of the div
            let text_elem = divElement.innerHTML;
            const regex = /(\d):(\d)/;

            let parts = text_elem.split(':');
            if (parts.length > 2) {
                parts[2] = '-' + parts[2];
                text_elem = parts.join(':').replace(':-', '-');
            }
            
            // Set the modified HTML back to the div
            divElement.innerHTML = text_elem;
        }
    });
});